export const setDataToStorage = (key: string, value: string) => {
    localStorage.setItem(key, value);
};
